export default __webpack_public_path__ + "static/media/list2.dbb40050.png";